import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { MoteLogo } from '@mote/assets/logo'
import { Localized } from '@fluent/react'
import { isInExtension } from '@mote/helpers/extension'
import { mote_primary } from '@mote/config/defaults/colors'
import { Text } from '@mote/ui'

export const Title = ({
  username,
  isPreparing,
  isPrivateComments,
  isLoading
}) => {
  const titleContainerRef = React.useRef(null)

  return (
    <TitleContainer ref={titleContainerRef}>
      <MoteLogo size={20} />
      {!isPreparing && !isPrivateComments && !isLoading && (
        <Localized
          id={
            isInExtension()
              ? 't--moter-sent-you-mote'
              : 'lpm--moter-sent-you-mote'
          }
          vars={{ moter: username }}
        >
          <TitleText data-testid='mote-title-text'>{'from {$moter}'}</TitleText>
        </Localized>
      )}
      {!isPrivateComments && isLoading && (
        <TitleText>
          <span>Loading your</span>{' '}
          <Text tag='p' fontSize={15} fontWeight={400} color={mote_primary}>
            mote
          </Text>
          ...
        </TitleText>
      )}
      {isPreparing && (
        <TitleText>
          Preparing your{' '}
          <Text tag='p' fontSize={15} fontWeight={400} color={mote_primary}>
            mote
          </Text>
          ...
        </TitleText>
      )}
      {!isPreparing && isPrivateComments && (
        <TitleText>
          <Text tag='p' fontSize={15} fontWeight={400} color={mote_primary}>
            mote
          </Text>
        </TitleText>
      )}
    </TitleContainer>
  )
}

Title.propTypes = {
  username: PropTypes.string,
  isPreparing: PropTypes.bool,
  isPrivateComments: PropTypes.bool,
  isLoading: PropTypes.bool
}

Title.defaultProps = {
  username: 'Someone',
  isPreparing: false,
  isPrivateComments: false,
  isLoading: false
}

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #646f7b;
  width: 83.3333%;
`

const TitleText = styled.h3`
  font-size: 15px !important;
  font-weight: normal !important;
  line-height: 120% !important;
  max-width: 100%;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0 !important;
  display: flex;
  gap: 5px;
  align-items: center;
`
